import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = {
  key: 0,
  class: "col md:col-6"
}
const _hoisted_3 = {
  key: 1,
  class: "col md:col-6"
}
const _hoisted_4 = { class: "col md:col-6" }
const _hoisted_5 = { class: "col md:col-6" }
const _hoisted_6 = { class: "col md:col-12" }
const _hoisted_7 = {
  key: 2,
  class: "col md:col-6"
}
const _hoisted_8 = {
  key: 3,
  class: "col md:col-6"
}
const _hoisted_9 = {
  key: 4,
  class: "col md:col-12"
}
const _hoisted_10 = { for: "emailYes" }
const _hoisted_11 = {
  key: 5,
  class: "col md:col-12"
}
const _hoisted_12 = { class: "col md:col-12" }
const _hoisted_13 = { class: "col md:col-12" }
const _hoisted_14 = {
  key: 6,
  class: "col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_AddressList = _resolveComponent("AddressList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.referenceType === 'employer')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_FormInput, {
            required: _ctx.required('company'),
            disabled: _ctx.disabled,
            value: _ctx.reference?.employerReference.company,
            error: _ctx.errors['company'],
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleUpdate($event, 'employerReference'))),
            label: "references.company",
            name: "company",
            id: "company"
          }, null, 8, ["required", "disabled", "value", "error"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.referenceType === 'employer')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_FormInput, {
            required: _ctx.required('userPosition'),
            disabled: _ctx.disabled,
            value: _ctx.reference?.employerReference.userPosition,
            error: _ctx.errors['userPosition'],
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleUpdate($event, 'employerReference'))),
            label: "references.user-position",
            name: "userPosition",
            id: "userPosition"
          }, null, 8, ["required", "disabled", "value", "error"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_DatePicker, {
        required: _ctx.required('dateRanges'),
        disabled: _ctx.disabled,
        value: _ctx.reference?.dateFrom,
        error: _ctx.errors['dateFrom'],
        onChange: _ctx.handleDateUpdate,
        label: "references.date-from",
        name: "dateFrom",
        id: "dateFrom"
      }, null, 8, ["required", "disabled", "value", "error", "onChange"])
    ]),
    _createVNode(_component_Checkbox, {
      class: "col sm:col-12",
      id: "presentDay",
      additionalClasses: "nofade",
      value: !!_ctx.reference?.presentDay,
      disabled: _ctx.disabled,
      name: "presentDay",
      text: 'references.presentDay-' + _ctx.referenceType,
      onChange: _ctx.handleUpdate
    }, null, 8, ["value", "disabled", "text", "onChange"]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.reference && _ctx.reference?.presentDay !== true)
        ? (_openBlock(), _createBlock(_component_DatePicker, {
            key: 0,
            required: _ctx.required('dateRanges'),
            disabled: _ctx.disabled,
            value: _ctx.reference?.dateTo,
            error: _ctx.errors['dateTo'],
            onChange: _ctx.handleDateUpdate,
            label: "references.date-to",
            name: "dateTo",
            id: "dateTo"
          }, null, 8, ["required", "disabled", "value", "error", "onChange"]))
        : _createCommentVNode("", true)
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col md:col-12" }, [
      _createElementVNode("h4", null, "Referee Details")
    ], -1)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_FormInput, {
        required: _ctx.required('name'),
        disabled: _ctx.disabled,
        value: _ctx.reference?.name,
        error: _ctx.errors['name'],
        onChange: _ctx.handleUpdate,
        label: "form.name",
        name: "name",
        id: "name"
      }, null, 8, ["required", "disabled", "value", "error", "onChange"])
    ]),
    (_ctx.referenceType === 'character')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_FormInput, {
            required: _ctx.required('howKnown'),
            disabled: _ctx.disabled,
            value: _ctx.reference?.characterReference.howKnown,
            error: _ctx.errors['howKnown'],
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleUpdate($event, 'characterReference'))),
            label: "references.how-known",
            name: "howKnown",
            id: "howKnown"
          }, null, 8, ["required", "disabled", "value", "error"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.referenceType === 'employer')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_FormInput, {
            required: _ctx.required('referencePosition'),
            disabled: _ctx.disabled,
            value: _ctx.reference?.employerReference.referencePosition,
            error: _ctx.errors['referencePosition'],
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleUpdate($event, 'employerReference'))),
            label: "references.position",
            name: "referencePosition",
            id: "referencePosition"
          }, null, 8, ["required", "disabled", "value", "error"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.disabled && !_ctx.mandatoryFields.includes('email'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _createVNode(_component_TranslatedText, { path: "references.email-known" })
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.disabled && !_ctx.mandatoryFields.includes('email'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_Radio, {
            id: "emailYes",
            value: "true",
            "model-value": _ctx.isEmailKnown,
            text: "common.yes",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isEmailKnown = 'true'))
          }, null, 8, ["model-value"]),
          _createVNode(_component_Radio, {
            id: "emailNo",
            value: "false",
            "model-value": _ctx.isEmailKnown,
            text: "common.no",
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isEmailKnown = 'false'))
          }, null, 8, ["model-value"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.isEmailKnown === 'true')
        ? (_openBlock(), _createBlock(_component_FormInput, {
            key: 0,
            required: _ctx.required('email'),
            type: "email",
            disabled: _ctx.disabled,
            value: _ctx.reference?.email,
            error: _ctx.errors['email'],
            onChange: _ctx.handleUpdate,
            label: "references.email",
            name: "email",
            id: "email"
          }, null, 8, ["required", "disabled", "value", "error", "onChange"]))
        : _createCommentVNode("", true),
      (_ctx.isEmailKnown === 'false')
        ? (_openBlock(), _createBlock(_component_FormInput, {
            key: 1,
            disabled: _ctx.disabled,
            value: _ctx.reference?.contactInfo,
            error: _ctx.errors['contactInfo'],
            onChange: _ctx.handleUpdate,
            label: "references.contact-information",
            name: "contactInfo",
            id: "contactInfo"
          }, null, 8, ["disabled", "value", "error", "onChange"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_FormInput, {
        required: _ctx.required('telephoneNumber'),
        disabled: _ctx.disabled,
        value: _ctx.reference?.telephoneNumber,
        error: _ctx.errors['telephoneNumber'],
        onChange: _ctx.handleUpdate,
        label: "form.telephone-number",
        name: "telephoneNumber",
        id: "telephoneNumber"
      }, null, 8, ["required", "disabled", "value", "error", "onChange"])
    ]),
    (_ctx.referenceType === 'employer')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("label", null, [
            _createVNode(_component_TranslatedText, { path: "form.address" })
          ]),
          _createVNode(_component_AddressList, {
            readonly: _ctx.disabled,
            addresses: _ctx.referenceAddress,
            limit: 1,
            hidePrimary: true,
            required: _ctx.mandatoryFields.includes('address'),
            onSave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleUpdateAddress($event, 'employerReference'))),
            onDelete: _ctx.handleRemoveAddress
          }, null, 8, ["readonly", "addresses", "required", "onDelete"])
        ]))
      : _createCommentVNode("", true)
  ]))
}